// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-fullscreen {
    height: 100vh;
  }
  
  .reactFlowContainer {
    width: 100%; 
  }
  
  .card-nofullscreen{
    height: 60vh; 
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/FlowCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd","sourcesContent":[".card-fullscreen {\n    height: 100vh;\n  }\n  \n  .reactFlowContainer {\n    width: 100%; \n  }\n  \n  .card-nofullscreen{\n    height: 60vh; \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
